import React from 'react';

import CharmaLogo from 'Shared/components/Logos/CharmaLogo';
import WpIcon from 'Wpds/components/icon/WpIcon';
import Colors from 'Wpds/colors/ColorConstants';
import ZoomLogo from 'Shared/components/Logos/ZoomLogo';

import './ZoomOnboardingPageWrapper.scss';

type Props = {
  children: React.ReactNode;
};

function ZoomOnboardingPageWrapper({ children }: Props) {
  return (
    <div className="ZoomOnboardingPageWrapper d-flex align-items-center  justify-content-center">
      <div className="ZoomOnboardingPageWrapper__content px-4 px-sm-5 pb-5 pt-4 d-flex flex-column justify-content-center align-items-center">
        <div className="d-flex w-100 justify-content-center align-items-center mt-3">
          <CharmaLogo width="160" className="mr-4" />
          <WpIcon name="plus" color={Colors.gray[700]} />
          <ZoomLogo height="18" className="ml-4" />
        </div>
        {children}
      </div>
    </div>
  );
}

export default ZoomOnboardingPageWrapper;
